import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/mvs';
import type { CategoryItem } from '@/mocks/mvs';

export default function CategoryNav() {
  const [activeCategory, setActiveCategory] = useState<string>('all');

  return (
    <section id="category-section" className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            探索音乐风格
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2">
            选择你喜欢的音乐类型，发现更多精彩MV
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          <Link
            to="/"
            className="group flex flex-col items-center gap-2 p-4 md:p-5 rounded-xl bg-background-100 hover:bg-primary-50 transition-all duration-300 hover:scale-105"
          >
            <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500 text-white group-hover:bg-primary-600 transition-colors">
              <i className="ri-fire-line text-xl md:text-2xl"></i>
            </div>
            <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
              全部
            </span>
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-2 p-4 md:p-5 rounded-xl bg-background-100 hover:bg-accent-50 transition-all duration-300 hover:scale-105"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-secondary-500 text-white group-hover:bg-accent-500 transition-colors">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-accent-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}